import React, { forwardRef, useEffect, useState } from "react";
import { Trans } from "@lingui/macro";
import PropTypes from "kf-proptypes/widgets";

import { i18n } from "base/i18n";

import {
  SEARCH_ICON_POSITIONS,
  SEARCH_SIZES,
  SEARCH_TYPE,
  SearchInput
} from "@widgets/inputs/index.jsx";
import {
  SingleSelectDropdown,
  SingleSelectDropdownItem,
  DROPDOWN_TYPE
} from "@widgets/inputs/dropdown/index.jsx";
import { OverflowText } from "@widgets/datadisplay/index.jsx";

import styles from "./search.css";

export function ColumnSearchInputBox(props) {
  const {
    size = COLUMN_SEARCH_SIZES.MEDIUM,
    value,
    dataSource,
    onSearch,
    onSelectedColumn,
    selectedColumn,
    onDropdownItemClick = () => {},
    onSearchInDropDown,
    placeholder,
    className,
    ...restProps
  } = props;
  const [dataList, setDataList] = useState([]);

  useEffect(
    function getSelectedList() {
      setDataList(dataSource);
    },
    [dataSource]
  );
  return (
    <div
      className={`${className} ${styles.columnSearch} ${
        styles[`${size}Size`]
      } `}
    >
      <SingleSelectDropdown
        paddingNone={true}
        className={styles.singleSelect}
        value={selectedColumn}
        size={SEARCH_SIZES[size.toLocaleUpperCase()]}
        dataSource={dataList}
        dropdownClassName={styles.dropDown}
        type={DROPDOWN_TYPE.MINIMAL}
        showClearIcon={false}
        labelRenderer={(data) => (
          <p className={`ellipsis ${styles.label} ${styles[`${size}Size`]} `}>
            {data.Name}
          </p>
        )}
        emptyRenderer={() => (
          <span className="base">
            <Trans>No fields found</Trans>
          </span>
        )}
        itemRenderer={(data) => {
          return (
            <SingleSelectDropdownItem value={data.Id} disabled={data.disabled}>
              <p
                className={`${styles.itemName} ${styles.dropDownLabel} ${
                  data.disable && styles.disable
                }`}
                onClick={(event) => {
                  onDropdownItemClick({ event, data });
                }}
              >
                <OverflowText line={1}>{i18n._(data.Name)}</OverflowText>
              </p>
            </SingleSelectDropdownItem>
          );
        }}
        onChange={(value) => {
          onSelectedColumn(value);
          setDataList(dataSource);
        }}
        onSearch={(item) => {
          if (item.search) {
            setDataList(onSearchInDropDown(item.search));
          } else {
            setDataList(dataSource);
          }
        }}
        {...restProps}
      />
      <div className={styles.divider} />
      <SearchInput
        type={SEARCH_TYPE.MINIMAL}
        size={SEARCH_SIZES[size.toLocaleUpperCase()]}
        className={styles.search}
        value={value}
        iconPosition={SEARCH_ICON_POSITIONS.LEFT}
        onChange={(event) => {
          onSearch(event.target.value);
        }}
        placeholder={placeholder}
        onClear={() => {
          onSearch("");
        }}
        {...restProps}
      />
    </div>
  );
}

export const COLUMN_SEARCH_SIZES = {
  BASE: "base",
  MEDIUM: "medium",
  SMALL: "small"
};

ColumnSearchInputBox.propTypes = {
  size: PropTypes.string,
  onSearch: PropTypes.func,
  value: PropTypes.string,
  dataSource: PropTypes.arrayOf(PropTypes.any),
  onSelectedColumn: PropTypes.func,
  selectedColumn: PropTypes.arrayOf(PropTypes.any),
  onSearchInDropDown: PropTypes.func,
  placeholder: PropTypes.string,
  className: PropTypes.string
};

export const ColumnSearchInput = forwardRef(ColumnSearchInputBox);
ColumnSearchInput.propTypes = ColumnSearchInputBox.propTypes;
